/**
 * FullCalendar Premium license key.
 *
 * Required by `@fullcalendar/adaptive`, the plugin that provides FullCalendar's
 * print-optimised rendering. Without a valid key the calendar renders a
 * "Your license key is invalid" banner over the view (PBI 6471).
 *
 * License: FullCalendar Premium 1-Developer, licensed to Simpson Thacher &
 * Bartlett, effective 2026-08-28. The vendor document and the full terms,
 * including the upgrade window and the developer-seat rule, are in
 * `licenses/README.md` at the repository root.
 *
 * This key is deliberately committed rather than injected through environment
 * configuration. `schedulerLicenseKey` is a client-side FullCalendar option, so
 * the value is compiled into the browser bundle and is visible to anyone who
 * opens the application. That is how the vendor intends it to work, and it is
 * not a secret in the sense of the repo's "do not hardcode secrets" rule.
 *
 * The key encodes its own purchase date. FullCalendar treats it as valid for any
 * release dated within roughly a year of that date, so upgrading FullCalendar
 * past the window in `licenses/README.md` needs a renewed key, not just a
 * version bump.
 */
export const FULLCALENDAR_LICENSE_KEY = '0610155261-fcs-1787930476';
